import api from "./api";

export const ListarSoftwaresIntegracao = async () => {
  try {
    const res = await api.get(`/integracoes/softwares`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const ListarIntegracoes = async () => {
  try {
    const res = await api.get(`/integracoes/configuracoes`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const CadastrarConfiguracaoIntegracao = async (id_integracao, data) => {
  try {
    const res = await api.post(`/integracoes/${id_integracao}/configuracoes`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const EditarConfiguracaoIntegracao = async (id_integracao, id, data) => {
  try {
    const res = await api.put(`/integracoes/${id_integracao}/configuracoes/${id}`, data);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const DeletarConfiguracaoIntegracao = async (id_integracao, id) => {
  try {
    const res = await api.delete(`/integracoes/${id_integracao}/configuracoes/${id}`);
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const TestarConexaoIntegracao = async (id_estabelecimento) => {
  try {
    const res = await api.get(
      `/integracoes/estabelecimento/${id_estabelecimento}/testar-conexao`,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const SetupEstruturaProdutoIntegracao = async (id_estabelecimento) => {
  try {
    const res = await api.post(
      `/integracoes/estabelecimento/${id_estabelecimento}/setup-estrutura-produtos`,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};

export const AtualizarJobIntegracao = async (id_estabelecimento) => {
  try {
    const res = await api.post(
      `/integracoes/estabelecimento/${id_estabelecimento}/atualizar-job-integracao`,
    );
    return res.data;
  } catch (error) {
    throw error;
  }
};
